import ErrorPage, {
  ErrorPageProps,
} from '@/components/basic/error-pages/error-page';
import {useInnerStyle} from '../proxy.hooks';
import React from 'react';
import Button from '@/components/basic/button';
import Text from '@/components/basic/text';
import theme from '@/style';
import globalStore from '@/services/global.state';
import {useConfirm} from '@basicComponents/modal';
import {useTranslation} from 'react-i18next';
import {goTo} from '@/utils';

export interface ErrorInvitePageProps extends Omit<ErrorPageProps, 'img'> {
  content: string;
  buttonTitle?: string;
  onClick?: () => void;
}

const ErrorInvitePage: React.FC<ErrorInvitePageProps> = ({
  content,
  buttonTitle,
  onClick,
  ...otherProps
}) => {
  const {
    size: {screenWidth, designWidth},
  } = useInnerStyle();
  const {i18n} = useTranslation();
  const userInfo = globalStore.userInfo;
  const {renderModal: renderPhoneConfirmModal, show: showPhoneConfirm} =
    useConfirm(i18n.t('label.confirm_btn'));
  const handlePress = () => {
    if (!userInfo?.userPhone) {
      showPhoneConfirm(
        i18n.t('label.friendly_reminder'),
        i18n.t('label.need_to_bind_phone'),
        () => {
          goTo('BindPhone');
        },
      );
      return;
    } else {
      onClick && onClick();
    }
  };
  return (
    <ErrorPage
      img={require('@components/assets/imgs/empty.webp')}
      {...otherProps}>
      <Text second size="medium" style={[theme.font.center, theme.margin.btml]}>
        {content}
      </Text>

      {buttonTitle && (
        <Button
          size="large"
          titleBold
          width={(174 * screenWidth) / designWidth}
          buttonStyle={{width: (174 * screenWidth) / designWidth}}
          title={buttonTitle}
          onPress={handlePress}
        />
      )}
      {renderPhoneConfirmModal}
    </ErrorPage>
  );
};

export default ErrorInvitePage;
